"use strict";
;
;
;
function IsSwap(obj) {
    return Object.keys(obj).length == 4 && obj.hasOwnProperty("x1") && obj.hasOwnProperty("y1") && obj.hasOwnProperty("x2") && obj.hasOwnProperty("y2");
}
function IsProp(obj) {
    return Object.keys(obj).length == 5 && obj.hasOwnProperty("x1") && obj.hasOwnProperty("y1") && obj.hasOwnProperty("x2") && obj.hasOwnProperty("y2") && obj.hasOwnProperty("prop");
}
function IsFinalStep(obj) {
    return Object.keys(obj).length == 2 && obj.hasOwnProperty("finalAddStep") && obj.hasOwnProperty("prop");
}
function IsReplayData(obj) {
    return !obj.hasOwnProperty("isOver");
}
class ReplayDataFormatter_v1 {
    constructor() { }
    format(org) {
        let index = 1;
        let temp = IsReplayData(org) ? org[1] : org;
        delete temp.newLevelEnd;
        let map = {};
        while (temp != null) {
            temp = Object.assign({}, temp);
            let item = {
                b: [temp.level, temp.randomSeed, temp.isOver ? 1 : 0, temp.lvmd5],
                s: this.formatSteps(temp.replaySteps)
            };
            let selectedItem = this.formatSelectedItemData(temp.selectedItemsData);
            if (selectedItem != null) {
                item.i = selectedItem;
            }
            let reviveItem = this.formatReviveItem(temp.reviveRef);
            if (reviveItem != null)
                item.r = reviveItem;
            delete temp.level;
            delete temp.randomSeed;
            delete temp.isOver;
            delete temp.selectedItemsData;
            delete temp.replaySteps;
            delete temp.reviveRef;
            if (Object.keys(temp).length > 0)
                item.o = temp;
            map[index] = item;
            if (IsReplayData(org))
                temp = org[++index];
            else
                temp = null;
        }
        return map;
    }
    unformat(formatted) {
        let org = formatted;
        let index = 1;
        let temp = org[index];
        let result = {};
        while (temp != null) {
            let item = {
                "level": temp.b[0],
                "randomSeed": temp.b[1],
                "replaySteps": this.unformatSteps(temp.s),
                "selectedItemsData": this.unformatSelectedItemData(temp.i),
                "isOver": temp.b[2] == 1,
                "lvmd5": temp.b.length >= 4 ? temp.b[3] : null
            };
            let reviveRef = this.unformatReviveItem(temp.r);
            if (reviveRef != null)
                item.reviveRef = reviveRef;
            if (temp.o != null)
                Object.assign(item, temp.o);
            result[index] = item;
            temp = org[++index];
        }
        return result;
    }
    formatSteps(orgSteps) {
        let swapStr = "";
        let propAry = [];
        let stepMap = {};
        let otherMap = {};
        let index = 1;
        let curStep = orgSteps[index];
        while (curStep != null) {
            this.deleteNullValues(curStep);
            if (IsSwap(curStep)) {
                swapStr += this.toAscii(curStep);
            }
            else if (IsProp(curStep)) {
                propAry.push(index, Number(`${curStep.x1}${curStep.y1}${curStep.x2}${curStep.y2}${curStep.prop}`).toString(32));
            }
            else if (IsFinalStep(curStep)) {
                stepMap[index] = `${curStep.finalAddStep ? 1 : 0}${curStep.prop}`;
            }
            else {
                otherMap[index] = curStep;
            }
            curStep = orgSteps[++index];
        }
        let result = { s: swapStr };
        if (propAry.length > 0)
            result.p = propAry;
        if (Object.keys(stepMap).length > 0)
            result.f = stepMap;
        if (Object.keys(otherMap).length > 0)
            result.o = otherMap;
        return result;
    }
    unformatSteps(orgSteps) {
        let result = {};
        if (orgSteps.p != null) {
            for (let i = 0; i < orgSteps.p.length; i += 2) {
                let str = parseInt(orgSteps.p[i + 1].toString(), 32).toString();
                result[Number(orgSteps.p[i])] = {
                    x1: Number(str[0]),
                    y1: Number(str[1]),
                    x2: Number(str[2]),
                    y2: Number(str[3]),
                    prop: Number(str.substr(4))
                };
            }
        }
        if (orgSteps.f != null) {
            for (let index in orgSteps.f) {
                result[index] = {
                    finalAddStep: orgSteps.f[index][0] == "1",
                    prop: Number(orgSteps.f[index].substr(1))
                };
            }
        }
        if (orgSteps.o != null) {
            for (let index in orgSteps.o) {
                result[index] = orgSteps.o[index];
            }
        }
        let swapStr = orgSteps.s;
        let swapIndex = 0;
        let curIndex = 1;
        while (swapIndex < swapStr.length - 1) {
            while (result.hasOwnProperty(curIndex))
                curIndex++;
            result[curIndex] = this.toV4(swapStr, swapIndex);
            curIndex++;
            swapIndex += 2;
        }
        return result;
    }
    formatSelectedItemData(selectedItemsData) {
        let ary = [];
        let index = 1;
        let value = selectedItemsData[index];
        while (!isNaN(value)) {
            ary.push(value.toString(32));
            value = selectedItemsData[++index];
        }
        return ary.length > 0 ? ary : null;
    }
    unformatSelectedItemData(value) {
        let map = {};
        if (value != null && value.length > 0) {
            for (let i = 0; i < value.length; i++) {
                map[i + 1] = parseInt(value[i], 32);
            }
        }
        return map;
    }
    formatReviveItem(reviveRef) {
        if (reviveRef != null) {
            let map = {};
            for (let key in reviveRef) {
                if (reviveRef[key].length > 0) {
                    map[key] = [];
                    reviveRef[key].forEach((v) => map[key].push(v.toString(32)));
                }
            }
            return Object.keys(map).length > 0 ? map : null;
        }
        else {
            return null;
        }
    }
    unformatReviveItem(reviveRef) {
        if (reviveRef != null) {
            let map = {};
            for (let key in reviveRef) {
                map[key] = [];
                reviveRef[key].forEach((v) => map[key].push(parseInt(v, 32)));
            }
            return map;
        }
        else {
            return null;
        }
    }
    deleteNullValues(obj) {
        let keys = Object.keys(obj);
        keys.forEach((key) => {
            if (obj[key] == null)
                delete obj[key];
        });
        return obj;
    }
    /**
     * 交换数据的xy范围为1-9，满足acsii可见字符范围[32-126]
     */
    toAscii(v4) {
        if (__DEBUG) {
            let ary = [v4.x1, v4.y1, v4.x2, v4.y2];
            ary.forEach((v => assert(v >= 1 && v <= 9, "swap data outof range! x1, y1, x2, y2 = " + ary.join(","))));
        }
        return String.fromCharCode(v4.x1 * 10 + v4.y1 + 22, v4.x2 * 10 + v4.y2 + 22);
    }
    toV4(str, index) {
        let code1 = str.charCodeAt(index) - 22;
        let code2 = str.charCodeAt(index + 1) - 22;
        return {
            x1: Math.floor(code1 / 10),
            y1: code1 % 10,
            x2: Math.floor(code2 / 10),
            y2: code2 % 10,
        };
    }
}
module.exports = ReplayDataFormatter_v1;
